import React from "react";
import { cn } from "@/lib/format";

// ---------- Cardanoscan-style raw ADA amount (whole.fraction ₳) ----------
export const AdaAmount = ({ lovelaceStr, tone }) => {
  const s = String(lovelaceStr ?? "0");
  // Pad to ≥7 digits so we can split off the last 6 as fractional
  const padded = s.padStart(7, "0");
  const whole = padded.slice(0, -6).replace(/^0+/, "") || "0";
  const frac = padded.slice(-6).replace(/0+$/, "") || "0";
  return (
    <span
      className={cn(
        "inline-flex items-baseline gap-1 font-mono tabnum",
        tone === "danger" ? "text-rose-400" : "text-foreground",
      )}
    >
      <span className="text-[18px] leading-none">
        {Number(whole).toLocaleString("en-US")}
      </span>
      <span className="text-[12px] leading-none text-muted-foreground/80">
        .{frac}
      </span>
      <span className="text-[14px] leading-none text-primary/70">₳</span>
    </span>
  );
};
